<template>
  <div
    class="modal black"
    id="filterModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Material Events
          </h5>
          <div class="action">
            <a @click="$emit('close')" aria-label="Close" class="cursor-pointer"
              ><i class="fa fa-times"></i
            ></a>
          </div>
        </div>
        <div class="modal-body">
            <div class="event-body">
    <div class="event-item">
      <span class="label info">Event Date</span>
      <span class="value">{{ eventData.eventDate || 'N/A' }}</span>
    </div>

    <div class="event-item">
      <span class="label danger">Event Code</span>
      <span class="value">{{ eventData.eventCode || 'N/A' }}</span>
    </div>

    <div class="event-item full">
      <span class="label info">Message</span>
      <span class="value muted">{{ eventData.messageText || 'N/A' }}</span>
    </div>
  </div>
        </div>
        <!-- closes modal-body -->
      </div>
      <!-- closes modal-content -->
    </div>
    <!-- closes modal-dialog -->
  </div>
  <!-- closes modal -->
</template>
<script>

export default {
  name: 'Material Event',
  components: {
    // Datepicker
  },
  props: {
    eventData: {
      type: Object,
      required: false
    }

  },
  data () {
    return {

    }
  },

}
      

</script>
<style scoped>
  .material-event-card {
  background: linear-gradient(180deg, #12152a, #0b0f1e);
  border-radius: 10px;
  padding: 16px 20px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

/* Header */
.event-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.event-header .title {
  font-size: 15px;
  font-weight: 600;
  color: #e5e7eb;
}

.close-btn {
  background: #1e2340;
  border: none;
  color: #9ca3af;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
}

/* Body */
.event-body {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px 24px;
}

.event-item {
  display: flex;
  flex-direction: column;
}

.event-item.full {
  grid-column: span 2;
}

/* Labels */
.label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}

.label.info {
  color: #38bdf8;
}

.label.danger {
  color: #ef4444;
}

/* Values */
.value {
  font-size: 14px;
  font-weight: 500;
  color: #f9fafb;
}

.value.muted {
  color: #cbd5f5;
}
</style>
